import { styled } from '@mui/material/styles';
import { DialogActions, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PREFIX = 'ClientOnboardingWizardFooter';

const classes = {
  footer: `${PREFIX}-footer`,
  button: `${PREFIX}-button`,
};

const Root = styled(DialogActions)(({ theme }) => ({
  [`&.${classes.footer}`]: {
    [theme.breakpoints.up('sm')]: {
      paddingRight: theme.spacing(18),
      paddingBottom: theme.spacing(4),
      paddingLeft: 0,
      gap: theme.spacing(2),
      '& button': {
        flex: 'none',
      },
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },

  [`& .${classes.button}`]: {
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      '&:not(:last-child)': {
        marginBottom: theme.spacing(1),
      },
    },
    width: '144px',
  },
}));

interface ClientOnboardingWizardFooterProps {
  isLast: boolean;
  isSaving: boolean;
  isValid: boolean;
  next: (data: any) => void;
  saveAndClose: () => void;
}

export default function ClientOnboardingWizardFooter({
  isLast,
  isSaving,
  isValid,
  next,
  saveAndClose,
}: ClientOnboardingWizardFooterProps) {
  const { t } = useTranslation('common');

  return (
    <Root className={classes.footer}>
      <Button
        color="primary"
        variant="contained"
        className={classes.button}
        disabled={!isValid || isSaving}
        onClick={next}>
        {isLast ? t('common.submit') : t('reservation.next')}
      </Button>
      <Button
        color="secondary"
        variant="outlined"
        className={classes.button}
        disabled={isSaving}
        onClick={saveAndClose}>
        {t('client.saveAndClose')}
      </Button>
    </Root>
  );
}
